/**
 * Attio's in-app settings URLs are workspace-scoped
 * (`app.attio.com/{workspace}/settings/developers/...`), and we can't know the
 * user's workspace slug — a bare `app.attio.com/settings/developers` link does
 * not resolve. Link the workspace-independent Help Center walkthrough instead.
 */
export const ATTIO_API_KEYS_URL =
  'https://attio.com/help/apps/other-apps/generating-an-api-key';

export interface AttioObjectType {
  /** The Ahoy entity type name submitted to the create-import endpoint. */
  name: string;
  /** Ahoy's name for the record type — the user lands on these after import. */
  label: string;
  /**
   * Attio's own name for this record type, shown to orient users migrating
   * from Attio. All three built-ins carry one (People, Companies, and Deals
   * in Attio).
   */
  description?: string;
}

export const ATTIO_OBJECT_TYPES: readonly AttioObjectType[] = [
  {
    name: 'ahoy_contact',
    label: 'Contact',
    description: 'Called "People" in Attio',
  },
  {
    name: 'ahoy_company',
    label: 'Company',
    description: 'Called "Companies" in Attio',
  },
  {
    name: 'ahoy_deal',
    label: 'Deal',
    description: 'Called "Deals" in Attio',
  },
];

/**
 * Maps a discovered custom object type (backend contract: `{ label,
 * entity_type_name }`) to the normalized `AttioObjectType` shape shared
 * with the built-ins. `entity_type_name` becomes `name` — the value the
 * wizard submits back in `selectedObjectTypes`.
 */
export function discoveredTypeToAttioObjectType(discovered: {
  label: string;
  entity_type_name: string;
}): AttioObjectType {
  return { name: discovered.entity_type_name, label: discovered.label };
}
